import styled from '@emotion/styled';
import { Container, media } from '@portalterreno/react-ui-core/Grid';

const StyledContainer = styled(Container)({
  [media('lg')]: {
    minHeight: '100vh',
    backgroundImage: `url("${process.env.NEXT_PUBLIC_IMAGES_HOST}/onboarding/background.webp")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '32.7% 100%'
  }
});

export default StyledContainer;
